import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getMyActions } from '../modules/auth';

// ----------------------------------------------------------------------
// 버튼별 권한 코드(ActionPermissionService). bito 4단계(2026-10-20).
// 메뉴 접근 권한(SYS_MENU_AUTH)과는 별개로 화면 안의 특정 버튼/동작 단위 권한이다.
// useComCodes가 baseCodes를 다루는 것과 같은 패턴: 로그인 후 처음 쓰일 때 1회 조회해 redux에
// 캐시하고, 이후로는 그 값을 재사용한다. 실제 차단은 서버가 다시 한다 — 여긴 버튼 노출/입력
// 차단 같은 화면 편의만 담당한다.
//
// 사용: const { allowed, loading } = useActionPermission('FORECAST_COPY');
export default function useActionPermission(code) {
  const dispatch = useDispatch();
  const { actions, user } = useSelector(({ auth }) => ({
    actions: auth.actions,
    user: auth.user,
  }));

  useEffect(() => {
    if (user && !actions) {
      dispatch(getMyActions());
    }
  }, [user, actions, dispatch]);

  if (!actions) {
    return { allowed: false, loading: true };
  }

  const allowed = Boolean(actions.isAdmin) || (actions.codes || []).includes(code);
  return { allowed, loading: false };
}
